module.exports = __webpack_public_path__ + "static/eggplant-c8acf759a8d094ac658e3025fd72f455.png";